export default "__VITE_ASSET__Dv70MtW0__"